import fvSubassembly from "../fvSubassembly"
export default class fvEllipseObj extends fvSubassembly {
	constructor(sContent, parent, system, callback) {
		super(sContent, parent, system);
		this.create();
		if (this.isDelayedWaiting) {
		this.complete = callback;
		} else {
		callback(this);
		}
		this.createSucss();
		this.isHide = true;
        if(this.animation.fvHide){
            this.isHide = false;
        }
	}
	init() {
		super.init();
		this.moveWidth = this.borderWidth / 2;
	}
	//绘制管道
	drawStereo(canvas){
		var byR0,byG0,byB0;
		var nR1,nG1,nB1;
		var Color = [];
		var rgbArr = [];
		rgbArr = this.borderColor.colorRgb();
		if(rgbArr.length != 3){
			byR0 = 0;
			byG0 = 0;
			byB0 = 255;
		}else{
			byR0 = rgbArr[0];
			byG0 = rgbArr[1];
			byB0 = rgbArr[2];
		}
		Color = this.lineTypeStyle.stereoColor.colorRgb();
		nR1 = Color[0];
		nG1 = Color[1];
		nB1 = Color[2];
		var fAddR,fAddG,fAddB;
		var w = Math.max(1,parseInt(this.borderWidth));
		fAddR = (nR1-byR0)/w;
		fAddG = (nG1-byG0)/w;
		fAddB = (nB1-byB0)/w;
		var i=0;
		var fWidthAdd;
		if(parseInt(this.borderWidth) <= 8){
			fWidthAdd = 2.0;
		}else{
			fWidthAdd = 2.0 * parseInt(this.borderWidth)/32.0 + 2.0;
		}
		i = -999;
		for(var fj =1.0; fj<=parseInt(this.borderWidth); fj+=fWidthAdd){
			if((i == Math.ceil(fj)) || (i+1 == Math.ceil(fj)))
			continue;
			i = Math.ceil(fj);//这三行代码保证只有在线宽差距较大时才画，提高了效率
			var colorStyle = "rgb(";
			var tempr = byR0+fAddR*i>255?255:byR0+fAddR*i;
			var tempg = byG0+fAddG*i>255?255:byG0+fAddG*i;
			var tempb = byB0+fAddB*i>255?255:byB0+fAddB*i;
			colorStyle += Math.ceil(tempr) + "," + Math.ceil(tempg) + "," + Math.ceil(tempb) + ")";
			canvas.strokeStyle = colorStyle;
			canvas.lineWidth = parseInt(this.borderWidth) + 1 - i;
			if(this.radius<0){
				this.radius = 0;
			}
			canvas.arc(this.centerX + this.moveWidth, this.centerY + this.moveWidth, this.radius, 0, 2*Math.PI,false);
			canvas.stroke();
		}
	}
	onDraw(canvas) {
		this.setCanvas(canvas)
        if(!this.isHide) return;
        if(!this.fcHide) return;
		this.formatRect();
		//判断宽度高度最少为1
		if(this.width == 0 ){
			this.width = 1;
		}
		if(this.height == 0 ){
			this.height = 1;
		}
		this.executePreAnimation(canvas);
		if (parseFloat(this.width) > parseFloat(this.height)) {
			this.scaleX = 1;
			this.scaleY = parseFloat(this.height) / parseFloat(this.width);
			this.radius = parseFloat(this.width) / 2;
		} else {
			this.scaleY = 1;
			this.scaleX = parseFloat(this.width) / parseFloat(this.height);
			this.radius = parseFloat(this.height) / 2;
		}
			this.centerX = (this.cx + parseFloat(this.width) / 2) / this.scaleX;
			this.centerY = (this.cy + parseFloat(this.height) / 2) / this.scaleY;
		if (this.borderWidth == 1) {
			canvas.setLineDash(this.lineStyle(this.lineType));
		}
		if (this.color == "" || this.opacity <= 0) {
			canvas.fillStyle = "rgba(255, 255, 255, 0)"; //矩形填充透明
		} else {
			var rgbArray = this.color.colorRgb(this.opacity / 255);;
			canvas.fillStyle = rgbArray; //矩形填充颜色
		}
		if (this.borderWidth == 0) {
			canvas.strokeStyle = "transparent";
		} else {
			canvas.strokeStyle = this.borderColor; //边框颜色
		}
		//设置线宽度
		if (this.borderWidth == 0) {
			canvas.lineWidth = 0.01;
		} else {
			canvas.lineWidth = this.borderWidth;
		}
		canvas.beginPath();
		canvas.save();
		canvas.scale(this.scaleX, this.scaleY);
		if(this.radius<0){
			this.radius = 0;
		}
		canvas.arc(this.centerX + this.moveWidth, this.centerY + this.moveWidth, this.radius, 0, 2*Math.PI,false);
		canvas.closePath();
		if (this.color && this.renderType == 0) {
			if (this.opacity > 0) {
				var rgbArray = this.color.colorRgb(this.opacity / 255);
				this.color = rgbArray;
			} else {
				var rgbArray1 = this.color.colorRgb(0.0001);
				this.color = rgbArray1;
			}
			canvas.fill();
		} else {
			canvas.clip();
			this.Render(canvas);
		}
		if(this.lineTypeStyle){
			if(this.lineTypeStyle.isStereo){ 
				this.drawStereo(canvas);
			}
		}
		canvas.stroke();
		this.executePosAnimation(canvas);
		canvas.restore();
	}
	// 椭圆存在缩放重写Render方法；
	Render(canvas) {
	//根据圆心中心点计算渐变的宽高 圆心 为this.centerX ，this.centerY
		var rect = {
			left : this.centerX - this.radius,
			top : this.centerY - this.radius,
			bottom : parseFloat(this.centerY + this.radius),
			right :parseFloat(this.centerX + this.radius),
			width : parseFloat(this.radius*2),
			height : parseFloat(this.radius*2)
		}
		if (this.render) {
		if(this.renderConfig.color){
			this.renderConfig.color[0] = this.color;
		}
		this.render.rend(canvas, rect, this);
		}
	};
}



// WEBPACK FOOTER //
// ./src/js/canvas/subUnit/fvEllipseObj.js